export const validateCookieConfig = process.env.NODE_ENV === 'development' || process.env.SNOOP_COOKIE_ENABLE_VALIDATION === 'true'
    ? require('./validate.dev').validateCookieConfig
    : () => true
